import { Avatar, Button } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY, FileCategories } from 'Enum';
import { CircleArrowRed, UploadFile } from 'Images';
import { FC, forwardRef } from 'react';
interface IUploadFileButton {
  clickHandler: () => void;
  children?: any;
  ariaLabel?: string;
  fileCategoryId?: FileCategories;
  caseDetailsId?: number;
  hospitalizationId?: number;
  dataRequired?: boolean;
  disabled?: boolean;
  error?: boolean;
}
export const UploadFileButton = forwardRef<
  HTMLButtonElement,
  IUploadFileButton
>((props, ref) => {
  return (
    <Button
      data-file-category-id={props.fileCategoryId}
      data-case-details-id={props.caseDetailsId}
      data-hospitalization-id={props.hospitalizationId}
      data-required={props.dataRequired ? 'true' : 'false'}
      ref={ref}
      variant='outlined'
      sx={{
        width: 'fit-content',
        marginBottom: 2,
        bgcolor: props.disabled ? '#838383 !important' : undefined,
        border: props.error ? '1px solid #D30024' : undefined,
        color: props.error ? '#D30024' : undefined,
      }}
      onClick={props.clickHandler}
      aria-label={
        props.ariaLabel
          ? props.ariaLabel
          : Dictionary[DICTIONARY.GENERAL].fileUploadLabel
      }
      endIcon={
        <Avatar
          alt=''
          src={props.error ? CircleArrowRed : UploadFile}
          sx={{ width: '18px', height: '18px' }}
        />
      }
      disabled={props.disabled}
    >
      {props.children}
    </Button>
  );
});
